
function $parcel$interopDefault(a) {
  return a && a.__esModule ? a.default : a;
}
// Import your styles so Parcel bundles them


var $a14afb4e0520e51d$exports = {};
$a14afb4e0520e51d$exports = JSON.parse('[{"title":"Rockabilly","medium":"Oil Pastels","year":"2026","image":"rockabilly"},{"title":"If only Craig David knew","medium":"Oil Pastels","year":"2026","image":"craigdavid"},{"title":"Moonhound 2","medium":"Oil Pastels","year":"2026","image":"moonhound2"},{"title":"Moonhound","medium":"Oil Pastels","year":"2026","image":"moonhound"},{"title":"\u5F8C - Behind","medium":"Acrylics","year":"2026","image":"behind"},{"title":"Potet","medium":"Oil Pastels","year":"2026","image":"potet"},{"title":"Every little help","medium":"Acrylics","year":"2025","image":"everylittlehelp"},{"title":"Al Dente","medium":"Acrylics collage","year":"2025","image":"aldente"},{"title":"Car Wash \xa310 - SOLD","medium":"Acrylics","year":"2025","image":"carwash10"},{"title":"Blues up - SOLD","medium":"Acrylics","year":"2025","image":"bluesup"},{"title":"Play as you are - SOLD","medium":"Acrylics","year":"2025","image":"playasyouare"},{"title":"Breathe up - SOLD","medium":"Acrylics","year":"2025","image":"breatheup"},{"title":"Where the woods end, there he bloomed","medium":"Acrylics","year":"2025","image":"greenman"},{"title":"Market Day - SOLD","medium":"Acrylics","year":"2025","image":"marketday"},{"title":"Farewell and thanks for all the graze","medium":"Acrylics","year":"2025","image":"ufo"},{"title":"Le Lobster Thermidors - Sold","medium":"Acrylics collage","year":"2025","image":"lobster"},{"title":"Sarapiqui","medium":"Acrylics","year":"2025","image":"sarapiqui"},{"title":"YUM (Imane\'s medal)","medium":"Acrylics","year":"2024","image":"imane"},{"title":"Inferno","medium":"Acrylics","year":"2024","image":"inferno"},{"title":"Game of Shrooms 2024 - Gone","medium":"3D Printed Sculpture","year":"2024","image":"shrooms2024"},{"title":"Queen for a day","medium":"Mixed media sculpture","year":"2024","image":"queenforaday"},{"title":"The Call to Merenda - Sold ","medium":"Acrylics","year":"2024","image":"calltomerenda"},{"title":"Crab Invaders - Sold ","medium":"Acrylics and wood collage","year":"2024","image":"crabinvaders"},{"title":"Underbirds #5 Pigeon ","medium":"Acrylics","year":"2024","image":"pigeon4theunderbirds"},{"title":"Underbirds #4 Sparrows - Sold","medium":"Acrylics","year":"2024","image":"sparrows"},{"title":"Underbirds #3 Primitive Bird","medium":"Acrylics","year":"2024","image":"primitive"},{"title":"Underbirds #2 Lapwings","medium":"Acrylics","year":"2024","image":"lapwing"},{"title":"Underbirds #1 70s Gannet","medium":"Acrylics","year":"2024","image":"gannet"},{"title":"Whodunnock (winner of the November 2023 LBAS competition)- SOLD","medium":"Watercolour collage","year":"2023","image":"whodunnock"},{"title":"The trouble with sitters - SOLD","medium":"Acrylics collage","year":"2023","image":"troublesitters"},{"title":"The reason why I am not allowed to redecorate a church","medium":"Acrylics","year":"2023","image":"church"},{"title":"Nonna\'s Sunday","medium":"Acrylics","year":"2023","image":"nonnas"},{"title":"Murmurations - SOLD","medium":"Acrylics","year":"2023","image":"murmurations"},{"title":"The most over-dramatic mating dance - SOLD","medium":"Acrylics collage","year":"2023","image":"overdrama"},{"title":"The 80s have been calling","medium":"Acrylics","year":"2023","image":"et"},{"title":"Pigeon","medium":"Air-dry clay","year":"2023","image":"pigeonclay"},{"title":"Sleeping pod","medium":"Acrylics","year":"2023","image":"sleepingpod"},{"title":"Mid morning snack","medium":"Gouache","year":"2023","image":"pelican"},{"title":"William Sheepspeare - SOLD","medium":"Watercolour","year":"2023","image":"sheep"},{"title":"Robin Redbreast","medium":"Markers and pencils","year":"2023","image":"robinredbreast"},{"title":"Onsen Macaque","medium":"Markers and pencils","year":"2023","image":"macaque"},{"title":"El Paraiso","medium":"Acrylics","year":"2022","image":"elparaiso"},{"title":"School of fish - SOLD","medium":"Gouache","year":"2022","image":"schooloffish"},{"title":"Norway - SOLD","medium":"Gouache","year":"2022","image":"norway"},{"title":"Koala - SOLD","medium":"Pencils and gouache","year":"2022","image":"koala"},{"title":"Sloth - SOLD","medium":"Pencils","year":"2022","image":"sloth"}]');


const $d30a5cc2cdc75246$var$gallery = document.querySelector('.gallery-grid');
const $d30a5cc2cdc75246$var$homeGallery = document.querySelector('.gallery-grid-home');
const $d30a5cc2cdc75246$var$SWIPE_THRESHOLD = 50;
// This function takes your JSON object and turns it into HTML
const $d30a5cc2cdc75246$var$renderGallery = (data)=>{
    let target;
    if ($d30a5cc2cdc75246$var$homeGallery) {
        target = $d30a5cc2cdc75246$var$homeGallery;
        const randomNine = (arr)=>[
                ...arr
            ].sort(()=>0.5 - Math.random()).slice(0, 9);
        data = randomNine((0, (/*@__PURE__*/$parcel$interopDefault($a14afb4e0520e51d$exports))));
    } else {
        target = $d30a5cc2cdc75246$var$gallery;
        data = (0, (/*@__PURE__*/$parcel$interopDefault($a14afb4e0520e51d$exports)));
    }
    target.innerHTML = data.map((item)=>`   
    <div class="gallery-item">
        <div class="image-container">
                <picture>
                    <source  srcset="/showcase/${item.image}.webp" type="image/webp">
                    <source  srcset="/showcase/${item.image}.jpg" type="image/jpg">
                    <img  src="/showcase/${item.image}.webp"
                         alt="${item.title}"/>
               </picture>
        </div>
        <div class="meta">${item.title} - ${item.medium} - ${item.year} </div>
    </div>
  `).join('');
};
// Execute the render
$d30a5cc2cdc75246$var$renderGallery((0, (/*@__PURE__*/$parcel$interopDefault($a14afb4e0520e51d$exports))));
const $d30a5cc2cdc75246$var$setupLightbox = ()=>{
    if (!$d30a5cc2cdc75246$var$gallery || $d30a5cc2cdc75246$var$homeGallery) return;
    const pictures = Array.from($d30a5cc2cdc75246$var$gallery.querySelectorAll('.gallery-item picture'));
    if (!pictures.length) return;
    const lightboxMarkup = `
        <div class="lightbox" aria-hidden="true">
            <button type="button" class="lightbox-close" aria-label="Close lightbox">&times;</button>
            <button type="button" class="lightbox-nav lightbox-prev" aria-label="Previous image">&#10094;</button>
            <figure class="lightbox-figure">
                <picture class="lightbox-picture"></picture>
                <figcaption class="lightbox-meta"></figcaption>
            </figure>
            <button type="button" class="lightbox-nav lightbox-next" aria-label="Next image">&#10095;</button>
        </div>
    `;
    document.body.insertAdjacentHTML('beforeend', lightboxMarkup);
    const lightbox = document.querySelector('.lightbox');
    const lightboxPicture = lightbox?.querySelector('.lightbox-picture');
    const lightboxMeta = lightbox?.querySelector('.lightbox-meta');
    const closeBtn = lightbox?.querySelector('.lightbox-close');
    const prevBtn = lightbox?.querySelector('.lightbox-prev');
    const nextBtn = lightbox?.querySelector('.lightbox-next');
    if (!lightbox || !lightboxPicture || !lightboxMeta || !closeBtn || !prevBtn || !nextBtn) return;
    let currentIndex = 0;
    let touchStartX = 0;
    const updateLightboxContent = (index)=>{
        const picture = pictures[index];
        if (!picture) return;
        lightboxPicture.innerHTML = picture.innerHTML;
        const image = lightboxPicture.querySelector('img');
        const meta = picture.closest('.gallery-item')?.querySelector('.meta')?.textContent || '';
        if (image) {
            image.decoding = 'async';
            image.loading = 'eager';
        }
        lightboxMeta.textContent = meta;
    };
    const openLightbox = (index)=>{
        currentIndex = index;
        updateLightboxContent(currentIndex);
        lightbox.classList.add('is-open');
        lightbox.setAttribute('aria-hidden', 'false');
        document.body.classList.add('lightbox-open');
    };
    const closeLightbox = ()=>{
        lightbox.classList.remove('is-open');
        lightbox.setAttribute('aria-hidden', 'true');
        document.body.classList.remove('lightbox-open');
    };
    const showNext = ()=>{
        currentIndex = (currentIndex + 1) % pictures.length;
        updateLightboxContent(currentIndex);
    };
    const showPrev = ()=>{
        currentIndex = (currentIndex - 1 + pictures.length) % pictures.length;
        updateLightboxContent(currentIndex);
    };
    pictures.forEach((picture, index)=>{
        const item = picture.closest('.gallery-item');
        if (!item) return;
        item.setAttribute('role', 'button');
        item.setAttribute('tabindex', '0');
        item.setAttribute('aria-label', 'Open image in lightbox');
        item.addEventListener('click', ()=>openLightbox(index));
        item.addEventListener('keydown', (event)=>{
            if (event.key === 'Enter' || event.key === ' ') {
                event.preventDefault();
                openLightbox(index);
            }
        });
    });
    closeBtn.addEventListener('click', closeLightbox);
    nextBtn.addEventListener('click', showNext);
    prevBtn.addEventListener('click', showPrev);
    lightbox.addEventListener('click', (event)=>{
        if (event.target === lightbox) closeLightbox();
    });
    lightbox.addEventListener('touchstart', (event)=>{
        touchStartX = event.changedTouches[0]?.clientX || 0;
    }, {
        passive: true
    });
    lightbox.addEventListener('touchend', (event)=>{
        const touchEndX = event.changedTouches[0]?.clientX || 0;
        const deltaX = touchEndX - touchStartX;
        if (Math.abs(deltaX) < $d30a5cc2cdc75246$var$SWIPE_THRESHOLD) return;
        if (deltaX > 0) showPrev();
        else showNext();
    }, {
        passive: true
    });
    document.addEventListener('keydown', (event)=>{
        if (!lightbox.classList.contains('is-open')) return;
        if (event.key === 'Escape') closeLightbox();
        else if (event.key === 'ArrowRight') showNext();
        else if (event.key === 'ArrowLeft') showPrev();
    });
};
document.addEventListener("DOMContentLoaded", ()=>{
    const items = document.querySelectorAll('.gallery-item');
    const observerOptions = {
        root: null,
        threshold: 0.15
    };
    const observer = new IntersectionObserver((entries)=>{
        entries.forEach((entry)=>{
            if (entry.isIntersecting) {
                // Add the 'active' class to trigger the CSS transition
                entry.target.classList.add('is-visible');
                // Once it's shown, we can stop observing it
                observer.unobserve(entry.target);
            }
        });
    }, observerOptions);
    items.forEach((item, index)=>{
        // Set a staggered delay based on the index (0.1s, 0.2s, etc.)
        // This creates that "Motion Minimalism" flow automatically
        item.style.transitionDelay = `${index % 3 * 0.15}s`;
        observer.observe(item);
    });
    $d30a5cc2cdc75246$var$setupLightbox();
});


//# sourceMappingURL=app.ea85fc46.js.map
